import { ResponseHandler } from '@reduxjs/toolkit/dist/query/fetchBaseQuery'

export const downloadFileHandler: ResponseHandler = async response => {
  if (response.ok) {
    const link = document.createElement('a')
    link.href = URL.createObjectURL(await response.blob())
    link.setAttribute('target', '_blank')
    link.click()
  }
  return response
}
